import { Field, NumericInput, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { Grid } from 'Components/Layout';
import { IWorksheetComponent, WorksheetGridFieldSection } from 'Components/Worksheets/Core';
import { actions } from 'Data/ReduxViewModels/WorksheetEditor';
import { hasNonEmptyValue, valueOrDefault } from 'Lib/Any';
import deepEquals from 'Lib/Object/deepEquals';
import { pipe } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';
import { Measurement } from '../../types';

interface IMeasurementGridFieldSection {
  disabled: boolean;
}

let MeasurementGridFieldSection: React.FC<IMeasurementGridFieldSection & IWorksheetComponent> = ({
  disabled,
  createWorksheetSelector,
  prefixName,
}) => {
  const measurements: Measurement[] = useSelector(
    pipe(createWorksheetSelector!('Measurements'), valueOrDefault([])),
    deepEquals
  );
  const measurementReadingDeletionConfirmation = ({ name }: any) =>
    hasNonEmptyValue(measurements[name]?.PenetrationReading);
  const dispatch = useDispatch();

  const handleCreateRow = () => {
    dispatch(
      actions.addArrayEntry({
        name: prefixName!('Measurements'),
        index: measurements.length,
        sync: true,
      })
    );
  };

  const handleRemoveRow = (row: number) => {
    dispatch(actions.removeArrayEntry({ name: prefixName!('Measurements'), index: row, sync: true }));
  };

  return (
    <WorksheetGridFieldSection name="Measurements">
      <Grid
        disabled={disabled}
        colHeaders={['Blows', 'Total Blows', 'Penetration Reading (mm)', 'Penetration (mm)', 'Depth (mm)']}
        data={createGridData(measurements, disabled)}
        onRemoveRow={handleRemoveRow}
        onCreateRow={handleCreateRow}
        rows={Array(2)
          .fill(undefined)
          .map((_, r) => ({ preventRemoveRow: r === 0 }))}
        removeConfirm={{
          confirm: measurementReadingDeletionConfirmation,
          confirmTitle: 'Measurement Reading Deletion',
          confirmText: 'Are you sure you want to remove the selected measurement reading?',
          confirmButtonText: 'Delete Reading',
        }}
      />
    </WorksheetGridFieldSection>
  );
};

const createGridData = (measurements: any[], disabled: boolean) => {
  var res = measurements.map((x: any, i: number) => [
    <Field disabled={disabled} input={i === 0 ? <TextOutput /> : <NumericInput />} name={`Measurements[${i}].Blows`} />,
    <Field input={<TextOutput />} name={`Measurements[${i}].TotalBlows`} />,
    <Field
      disabled={disabled}
      input={i === 0 ? <TextOutput /> : <NumericInput />}
      name={`Measurements[${i}].PenetrationReading`}
    />,
    <Field input={<TextOutput />} name={`Measurements[${i}].Penetration`} />,
    <Field input={<TextOutput />} name={`Measurements[${i}].Depth`} />,
  ]);

  return res;
};

MeasurementGridFieldSection = withInjectedProps(MeasurementGridFieldSection);
export { MeasurementGridFieldSection };
export default MeasurementGridFieldSection;
